import type React from 'react';
import classNames from 'classnames';
import {
  useIsFixHeaderEnabled,
  useStickySitewideSliderNavWidget,
} from './hooks';
import SliderNavigationWidgetSkeleton from '../../components/SliderNavigation/components/Skeleton';
import type { TSliderNavigationWidget } from './types';

import styles from './index.module.css';

interface IProps {
  children: React.ReactNode | React.ReactNode[];
  config: TSliderNavigationWidget['config'];
}

export const StickyContainer = ({ children, config }: IProps) => {
  const isFixHeaderEnabled = useIsFixHeaderEnabled();
  const isFixed = useStickySitewideSliderNavWidget();

  return (
    <>
      {isFixed && (
        <SliderNavigationWidgetSkeleton
          className={styles.filler}
          config={config}
        />
      )}

      <div
        className={classNames(
          styles.wrapper,
          isFixed && styles.sticky,
          isFixHeaderEnabled && styles.stickyFixedHeader
        )}
      >
        {children}
      </div>
    </>
  );
};
